import { useCallback, useEffect, useState, createRef, useRef } from 'react'
import { useEffectOnce } from 'usehooks-ts'
import styled from 'styled-components'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'

const YearItem = ({
  tenant,
  colorMode,
  year,
  index,
  total,
  text,
  logos,
}: {
  tenant?: object
  colorMode?: string
  year: number
  index: number
  total: number
  text: string
  logos: any
}) => {
  const [isMobile, setIsMobile] = useState(false)

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 600)
  }

  useEffectOnce(() => {
    // set height when window is resized
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return (
    <Yearitem
      className={`${index % 2 ? 'odd' : 'even'} ${
        colorMode === 'dark' ? 'dark' : ''
      }`}
    >
      <div className='left'>
        <div
          className={
            index === 0
              ? 'first line'
              : index === total - 1
              ? 'last line'
              : 'line'
          }
        />
        <span className={index % 2 ? 'dot odd' : 'dot even'}>
          <span className='inner' />
        </span>
      </div>
      <div className='right'>
        <h4>{year}</h4>
        <div className='content'>
          {logos.map(function (logo: any, itemIndex: number) {
            return (
              <div className='logo'>
                <img
                  src={require('../../images/' + logo + '.jpg')}
                  alt={'Logo ' + text[itemIndex]}
                />
                <span className='txt'>{text[itemIndex]}</span>
              </div>
            )
          })}
        </div>
      </div>
    </Yearitem>
  )
}
const Yearitem = styled.div`
  display: grid;
  grid-template-columns: 22px 96%;
  padding: 0;
  font-size: 1.4rem;
  color: var(--text-color);
  &.even {
    background-color: var(--even-background);
    &.dark {
      background-color: rgb(38, 38, 38);
    }
  }

  .left {
    text-align: center;
    display: grid;
    grid-auto-rows: 1fr;
    position: relative;
    padding-left: 1rem;
    .line {
      background: linear-gradient(var(--text-color), var(--text-color))
        no-repeat center/1px 100%;
      &.first {
        height: 80%;
        top: 2rem;
        position: relative;
      }
      &.last {
        height: 2rem;
      }
    }
    .dot {
      position: absolute;
      top: 1.2rem;
      left: 0.7rem;
      height: 1.8rem;
      width: 1.8rem;

      border-radius: 50%;
      display: inline-block;
      &.odd {
        background-color: var(--site-background);
      }
      &.even {
        background-color: var(--even-background);
      }

      .inner {
        position: absolute;
        top: 0.4rem;
        left: 0.4rem;
        height: 1rem;
        width: 1rem;
        background-color: var(--text-color);
        border-radius: 50%;
        display: inline-block;
      }
    }
  }

  .right {
    padding: 0.6rem 1rem 0.4rem;
    h4 {
      font-size: 1.5rem;
      margin: 0;
    }
    .content {
      padding: 0;
      .logo {
        position: relative;
        display: inline;
        white-space: nowrap;
        margin-right: 1.5rem;
        max-height: 25px;
        img {
          max-width: 45px;
          margin-right: 0.5rem;
          max-height: 25px;
        }
        .txt {
          display: inline-block;
          font-size: 1.2rem;
          bottom: 5px;
          position: relative;
        }
      }
    }
  }
`

export default YearItem
